<script setup lang="ts">
import WidgetRecordAction from '@components/widget/WidgetRecordAction.vue'

const { records, isSelected } = defineProps<{
  records: any[],
  isSelected: Function,
}>()

const emit = defineEmits(['set', 'getRecords', 'select', 'unselect', 'isSelected'])
</script>

<template>
  <VTable v-if="records?.length">
    <thead>
      <tr>
        <th>ID</th>
        <th>Название</th>
        <th>Тип курса</th>
        <th class="text-center mw-100">
          Действие
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="record in records"
        :key="record.Uuid"
        :class="{ 'tr-deleted': record?.Bundle?.IsDeleted || record?.IsDeleted }"
      >
        <td>{{ record.Bundle.Id || record.Id || '—' }}</td>
        <td>
          <RouterLink
            v-if="record.Bundle?.Uuid"
            :to="{ name: 'course', params: { uuid: record.Bundle.Uuid }, query: { tab: 'preview' } }"
            target="_blank"
          >
            {{ record.Name || '—' }}
          </RouterLink>
          <div v-else>
            —
          </div>
        </td>
        <td>{{ record.TypeName || '—' }}</td>
        <td class="text-center">
          <WidgetRecordAction
            :selected="isSelected(record.Uuid)"
            @set="emit('select', record)"
            @delete="emit('unselect', record)"
          />
        </td>
      </tr>
    </tbody>
  </VTable>

  <VListItem v-else>
    Нет данных.
  </VListItem>
</template>

<style lang="scss" scoped>
.form-component-bottom {
  display: flex;
  align-items: center;
}

.form-component-bottom__pagination {
  flex-grow: 1;
}
</style>
